import { Controller } from "@hotwired/stimulus";

// TopNav::SpaceSwitcherComponent — toggles the dropdown of available
// spaces. Click trigger to open; Esc, outside click, or a menu-item
// activation closes the menu.
export default class extends Controller {
  static targets = ["trigger", "menu"];

  toggle(event) {
    event.preventDefault();
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.hasMenuTarget) return;
    this.menuTarget.hidden = false;
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "true");
    }
  }

  close() {
    if (!this.hasMenuTarget) return;
    this.menuTarget.hidden = true;
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "false");
    }
  }

  closeOnOutsideClick(event) {
    if (!this.isOpen()) return;
    if (this.element.contains(event.target)) return;
    this.close();
  }

  isOpen() {
    return this.hasMenuTarget && !this.menuTarget.hidden;
  }
}
